import { useSelector } from "react-redux";

const useUserGeoLocation = () => {
    const userGeoData = useSelector(state => state.user.userGeoData);
    return userGeoData;
};

export default useUserGeoLocation;
